// Angular
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { isArray } from 'ngx-bootstrap/chronos';

@Injectable()
export class FunctionsUtilsService {
	/**
	 * Service constructor
	 *
	 * @param snackBar: MatSnackBar
	 * @param dialog: MatDialog
	 */
	translateInstant: any;
	constructor(private translate: TranslateService,) {
		this.translateInstant = this.translate.instant;
	}

	getDir() {
		return this.translate.currentLang == 'en' || this.translate.currentLang == 'hi' ? 'ltr' : 'rtl';
	}

	getAllFormErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
		let hasError = false;
		const result = Object.keys(form.controls).reduce((acc, key) => {
			const control = form.get(key);
			const errors = (control instanceof FormGroup || control instanceof FormArray)
				? this.getAllFormErrors(control)
				: control?.errors;
			if (errors) {
				acc[key] = errors;
				hasError = true;
			}
			return acc;
		}, {} as { [key: string]: any; });
		return hasError ? result : null;
	}

	prepereErrorMessage(error: any) {
		if (error && error.error && error.error.message) {
		  let message = error.error.message;
		  if (isArray(message)) {
			return message.join('<br>');
		  } else {
			return message;
		  }
		} else {
		  return this.translate.instant('SOME_ERROR_HAPPENED');
		}
	}



}
